import { useEffect, useState } from "react";
import "../../../src/App.css";
import { mailicon, clipboard } from "../../assets/Exportimageicon";
import Footer from "../../Components/footer/Footer";
import service from "../../services/service";
import endpoints from "../../services/endpoints";

export default function Contact() {
  const [copied, setCopied] = useState(false);
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCommunityData = async () => {
      try {
        const res = await service.get(
          endpoints.community.record,
          {},
          {
            skipToast: true,
          }
        );
        const data = res?.data?.data?.data;

        setEmail(data?.contactEmail || "Support@ascendor.com");
      } catch (error) {
        console.error("Error fetching contact email:", error);
        setEmail("Support@ascendor.com");
      } finally {
        setLoading(false);
      }
    };

    fetchCommunityData();
  }, []);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(email);
      setCopied(true);

      setTimeout(() => {
        setCopied(false);
      }, 2000);
    } catch (error) {
      console.error("Copy failed:", error);
    }
  };

  return (
    <div className="contact-root">
      <main className="c-main mt-5">
        <div className="c-left">
          <h1 className="c-heading">Get In Touch</h1>

          <p className="c-subtext">
            Whether you have a question, want to work together,
            or simply wish to say hello, I'm all ears.
          </p>
        </div>

        <div className="c-card-wrap">
          <div className="c-card">
            <div className="c-card-top">
              <img src={mailicon} alt="Mail" />
            </div>

            <div className="c-card-bottom">
              <p className="c-card-label">
                Reach out to our support team via
              </p>

              <div className="c-card-email-row">
                {loading ? (
                  <span className="c-card-email">Loading...</span>
                ) : (
                  <a
                    href={`mailto:${email}`}
                    className="c-card-email"
                  >
                    {email}
                  </a>
                )}

                <button
                  className={`c-copy-btn ${
                    copied ? "copied" : ""
                  }`}
                  onClick={handleCopy}
                  title={copied ? "Copied!" : "Copy email"}
                  disabled={loading}
                >
                  <img src={clipboard} alt="Copy" />
                </button>
              </div>

              {copied && (
                <p
                  style={{
                    color: "#22c55e",
                    marginTop: "10px",
                    fontSize: "14px",
                  }}
                >
                  Email copied!
                </p>
              )}
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}